export default __webpack_public_path__ + "static/media/ic_times_orange.f7d093ca.svg";